import { Fragment, memo, ReactElement, useEffect, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import FormFilterNewPerson from './form';
import { PersonalDataVM } from 'shell/view-models/personal-data';

interface AccordionFilterProps {
  onChange: (key: keyof PersonalDataVM, value: PersonalDataVM[keyof PersonalDataVM]) => void;
  values?: PersonalDataVM;
  disabled?: boolean;
  resetForm?: () => void;
  onChangeFields: (values: PersonalDataVM) => void;
  onSearch: () => void;
}

const AccordionFilterComponent = ({
  onChange,
  values,
  disabled,
  resetForm,
  onChangeFields,
  onSearch,
}: AccordionFilterProps): ReactElement => {
  const [open, setOpen] = useState<boolean>(!disabled);

  useEffect(() => {
    if (disabled) {
      setOpen(false);
    }
  }, [disabled]);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="filter"
          id="filter"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormFilterNewPerson
            onChange={onChange}
            values={values}
            resetForm={resetForm}
            disabled={disabled}
            onChangeFields={onChangeFields}
            onSearch={() => {
              setOpen(false);
              onSearch();
            }}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionFilterComponent.displayName = 'Filtri persona';

const AccordionFilter = memo(AccordionFilterComponent);

export default AccordionFilter;
